"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var StageSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6C9 6.09868 9.00476 6.19625 9.01408 6.29249L4.311 11.5181L5.04288 12.25L3.14645 14.1464C2.95118 14.3417 2.95118 14.6583 3.14645 14.8536C3.34171 15.0488 3.65829 15.0488 3.85355 14.8536L5.74999 12.9571L6.48187 13.689L11.7075 8.98592C11.8038 8.99524 11.9013 9 12 9ZM13.7231 7.01598C13.899 6.71823 14 6.3709 14 6C14 4.89543 13.1046 4 12 4C11.6291 4 11.2818 4.10096 10.984 4.27691L13.7231 7.01598ZM13.016 7.72309C12.7182 7.89904 12.3709 8 12 8C10.8954 8 10 7.10457 10 6C10 5.6291 10.101 5.28177 10.2769 4.98402L13.016 7.72309ZM5.68898 11.4819L9.35221 7.41164C9.63241 7.93612 10.0639 8.36759 10.5884 8.6478L6.51811 12.311L5.68898 11.4819Z", fillRule: "evenodd", clipRule: "evenodd" })));
};
StageSmall.displayName = 'StageSmall';
exports.default = StageSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=StageSmall.js.map